import { render } from "./ProfilePhoneEdit.vue?vue&type=template&id=323f5228&lang=pug"
import script from "./ProfilePhoneEdit.vue?vue&type=script&lang=js"
export * from "./ProfilePhoneEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__